/**
 * Shared secondary-CTA handler: scroll (or navigate) to the main purchase area.
 * Does not add to cart. Primary routine ATC stays on qeviq-shared-add-to-cart.js.
 */
(function () {
  const TARGET_ID = 'qeviq-purchase-options';
  const ATTR = 'data-qeviq-scroll-to-purchase';
  const HASHES = ['#' + TARGET_ID, '#qeviq-buy-cta'];

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function getHeaderOffset() {
    let bottom = 0;
    [
      document.querySelector('.qeviq-header-shell'),
      document.querySelector('sticky-header'),
      document.querySelector('#shopify-section-header.shopify-section-header-sticky'),
    ].forEach((el) => {
      if (!el) return;
      const rect = el.getBoundingClientRect();
      if (rect.height > 0 && rect.bottom > 0 && rect.top < 120) {
        bottom = Math.max(bottom, rect.bottom);
      }
    });

    const styles = getComputedStyle(document.documentElement);
    const dawnHeader = parseFloat(styles.getPropertyValue('--header-height')) || 0;
    const qeviqHeader = parseFloat(styles.getPropertyValue('--qeviq-header-height')) || 0;
    const announce = document.documentElement.classList.contains('qeviq-chrome-scrolled')
      ? 0
      : parseFloat(styles.getPropertyValue('--qeviq-announce-height')) || 0;

    return Math.max(bottom, dawnHeader, qeviqHeader + announce) + 12;
  }

  function resolveTarget() {
    const purchase = document.getElementById(TARGET_ID);
    if (purchase) {
      const colour =
        purchase.querySelector('variant-selects') ||
        document.querySelector('product-info.product-info--qeviq variant-selects');
      if (colour && !purchase.contains(colour)) return colour;
      return purchase;
    }

    return (
      document.getElementById('qeviq-buy-cta') ||
      document.querySelector('product-info.product-info--qeviq .qbs--plans') ||
      document.querySelector('product-info.product-info--qeviq')
    );
  }

  function scrollToPurchase() {
    const target = resolveTarget();
    if (!target) return false;

    const offset = getHeaderOffset();
    target.style.scrollMarginTop = offset + 'px';

    target.scrollIntoView({
      behavior: prefersReducedMotion() ? 'auto' : 'smooth',
      block: 'start',
    });
    return true;
  }

  function isSamePage(href) {
    if (!href || href.startsWith('#')) return true;
    try {
      const url = new URL(href, window.location.href);
      return url.pathname === window.location.pathname;
    } catch (e) {
      return false;
    }
  }

  function destinationFromTrigger(trigger) {
    return (
      trigger.getAttribute('data-qeviq-purchase-url') ||
      trigger.getAttribute('href') ||
      ''
    );
  }

  function navigateToProductTop(href) {
    if (!href) return;
    try {
      const url = new URL(href, window.location.href);
      /* New pages must open at the top — never force a purchase hash. */
      if (HASHES.indexOf(url.hash) !== -1) url.hash = '';
      window.location.assign(url.pathname + url.search + url.hash);
    } catch (e) {
      window.location.href = String(href).split('#')[0];
    }
  }

  function onClick(event) {
    const trigger = event.target.closest('[' + ATTR + ']');
    if (!trigger) return;

    const href = destinationFromTrigger(trigger);
    if (href && !isSamePage(href)) {
      event.preventDefault();
      navigateToProductTop(href);
      return;
    }

    event.preventDefault();
    if (scrollToPurchase()) return;
    if (href) navigateToProductTop(href);
  }

  function handleHash() {
    if (HASHES.indexOf(window.location.hash) === -1) return;
    scrollToPurchase();
  }

  document.addEventListener('click', onClick);

  /*
    Any storefront link to another page that deep-links into the purchase block
    would open mid-gallery. Strip that hash on cross-page clicks so new pages
    start at the top. Same-page #qeviq-purchase-options CTAs still scroll.
  */
  document.addEventListener(
    'click',
    function (event) {
      if (event.defaultPrevented) return;
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      if (event.button != null && event.button !== 0) return;

      const link = event.target.closest('a[href]');
      if (!link) return;
      if (link.hasAttribute(ATTR)) return;
      if (link.getAttribute('target') && link.getAttribute('target') !== '_self') return;
      if (link.hasAttribute('download')) return;

      let url;
      try {
        url = new URL(link.href, window.location.href);
      } catch (e) {
        return;
      }

      if (url.origin !== window.location.origin) return;
      if (HASHES.indexOf(url.hash) === -1) return;
      if (url.pathname === window.location.pathname) return;

      event.preventDefault();
      window.location.assign(url.pathname + url.search);
    },
    true
  );

  if (document.readyState === 'complete') {
    handleHash();
  } else {
    window.addEventListener('load', handleHash);
  }

  window.QeviqScrollToPurchase = {
    scrollToPurchase: scrollToPurchase,
    targetId: TARGET_ID,
  };
})();
